module.exports = __webpack_public_path__ + "img/img-a7960fc7.9887a6df.png";